import { ArrowUpRight } from 'lucide-react';
import type { KPI } from '../types';

export function MetricCard({ metric }: { metric: KPI }) {
  return (
    <article className={`metric-card metric-card--${metric.tone}`}>
      <div className="metric-top"><span>{metric.label}</span><ArrowUpRight size={17} /></div>
      <strong>{metric.value}</strong>
      <div className="metric-meta"><span>{metric.delta}</span><small>{metric.hint}</small></div>
    </article>
  );
}

